/** Inbox processing lifecycle states. */
export enum InboxMessageStatus {
  Pending = 'Pending',
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed',
  Parked = 'Parked',
  Cancelled = 'Cancelled'
}

/** Outbox delivery lifecycle states. */
export enum OutboxMessageStatus {
  Pending = 'Pending',
  Processing = 'Processing',
  Delivered = 'Delivered',
  Failed = 'Failed',
  Parked = 'Parked',
  Cancelled = 'Cancelled'
}

/** Supported transports for message delivery. */
export enum MessageBroker {
  RabbitMq = 'rabbitmq',
  Nats = 'nats',
  Http = 'http'
}

/** Reasons why a message is blocked from processing. */
export enum BlockingReason {
  /** No blocking - message is ready. */
  None = 'none',
  /** Rate limit tokens exhausted. */
  RateLimited = 'rate_limited',
  /** Concurrency slots exhausted. */
  ConcurrencyFull = 'concurrency_full',
  /** Ingress admission rejected. */
  IngressRejected = 'ingress_rejected',
  /** Scheduled for future execution. */
  Scheduled = 'scheduled',
  /** Waiting for retry backoff. */
  RetryBackoff = 'retry_backoff'
}
